import {NavigateOptions, To, useLocation, useNavigate} from "react-router-dom";
import {UrlLiteral} from "_types/swr";
import {StrNum} from "_types";
import {entries} from "_utils/obj";


export const _ = <P extends StrNum[]>(...args: P): UrlLiteral<P> => joinUrl(args);

export function joinUrl<P extends StrNum[]>(key: P) {
    const url = key
        .join('/')
        .replace(/([^:])\/{2,}/g, '$1/')
        .replace(/\/$/, '')
        .replace(/\/\?/, '?');

    return url as UrlLiteral<P>;
}

export const n = (...route: string[]) => {
    return {pathname: _(...route)};
}

export const useGo = () => {
    const navigate = useNavigate();
    return (...route: string[]) => navigate(n(...route));
}

export const useGoQuery = () => {
    const navigate = useNavigate();
    return ({route, query = ''}: { route: string, query: string }) => navigate({
        pathname: route,
        search: query
    });
}

export const useUrlQuery = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const all = () => {
        const a = {} as Record<string, string>;
        queryParams.forEach((value, key) => a[key] = value);
        return a;
    };

    const get = (key: string) => queryParams.get(key);

    return [all, get] as const;
}

export const useRelativeGo = () => {
    const navigate = useNavigate();
    return (...route: string[]) => navigate(route.join('/'));
}

export const useGoBack = () => {
    const navigate = useNavigate();
    return (delta = -1) => navigate(delta);
}

export function query(query: Record<string, any>): URLSearchParams;
export function query(query: Record<string, any>, prefix: string): string;
export function query(query: Record<string, any>, prefix?: string) {
    const filtered = entries(query).reduce((acc, [key, val]) => {
        if ((val ?? null) !== null) {
            if (typeof val === 'boolean') val = +val;

            acc[key] = val;
        }

        return acc;
    }, {} as Record<string, string>);

    const params = new URLSearchParams(filtered);

    if (prefix) {
        return prefix + params;
    }

    return params;
}

type NavigateType = {
    go: (...route: string[]) => void
    navigate: (to: To, Optionaloptions?: NavigateOptions) => void;
}

export const Route: NavigateType = {
    go: (...route: string[]) => {
    },
    navigate: (to: To, Optionaloptions?: NavigateOptions) => {
    }

};


